module.exports = __webpack_public_path__ + "img/suits.16ae2065.webp";